import React from 'react';

const TextFieldLabel = (props) => {
	const { className, label, children, id } = props;
	return (
		<label id={id} className={`label-input${className ? " " + className : ""}`}>{label ? label : children}</label>
	)	
}

export default TextFieldLabel;